import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SCOPETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ScopeType.Name')
    .required()
    .maxLength(100)
    .build(),
];

export const SCOPETYPE_CONFIG = {
  entityName: 'ScopeType',
  localizationKey: 'Controlling::Entity.ScopeType',
  fields: SCOPETYPE_FIELDS,
  permission: 'ControllingActivities.ScopeTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
